interface StateType {
    name: string;
    loading: boolean;
}
export default {
    state: {
        name: 'common',
        loading: false
    },
    getters: {
        loading(state: StateType): boolean {
            return state.loading;
        }
    },
    mutations: {
        updateLoading(state: StateType, playLoad: boolean): void {
            state.loading = playLoad;
        }
    },
    actions: {},
    modules: {},
    namespaced: true
};
